/// <amd-module name="SuiteCommerce.GiftCertificate.ValueCheck.Result.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.GiftCertificate.ValueCheck.Result.View", ["require", "exports", "Backbone", "SuiteCommerce.GiftCertificate.ValueCheck.Configuration", "SuiteCommerce.GiftCertificate.ValueCheck.Model", "SuiteCommerce.GiftCertificate.Utils", "value_check_result.tpl"], function (require, exports, Backbone_1, ValueCheck_Configuration_1, ValueCheck_Model_1, Utils_1, template) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ValueCheckResultView = void 0;
    var ValueCheckResultView = /** @class */ (function (_super) {
        __extends(ValueCheckResultView, _super);
        function ValueCheckResultView(options) {
            var _this = _super.call(this, options) || this;
            _this.application = options.application;
            _this.template = template;
            return _this;
        }
        ValueCheckResultView.prototype.getContext = function () {
            var expirationDate = this.model.get('expirationDate');
            return {
                expirationDate: Utils_1.Utils.formatDate(expirationDate),
                giftCertificateCode: this.model.get('giftcertcode'),
                amountRemaining: this.model.get('amountRemainingFormatted'),
                isAmountRemainingGreaterThanZero: Number(this.model.get('amountRemaining')) > 0,
                hasExpirationDate: !!expirationDate,
                showExpirationDateInformation: this.model.get('status') === ValueCheck_Model_1.GiftCertificateStatus.expired || Number(this.model.get('amountRemaining')) > 0,
                isCodeExpired: this.model.get('status') === ValueCheck_Model_1.GiftCertificateStatus.expired,
                expiredCodeMessage: ValueCheck_Configuration_1.ValueCheckConfiguration.expiredCodeMessage,
                remainingBalanceLabel: ValueCheck_Configuration_1.ValueCheckConfiguration.remainingBalanceLabel,
                gifCertificateCodeLabel: ValueCheck_Configuration_1.ValueCheckConfiguration.giftCertificateCodeLabel,
                codeExpiredLabel: ValueCheck_Configuration_1.ValueCheckConfiguration.codeExpiredLabel,
                expiryDateLabel: ValueCheck_Configuration_1.ValueCheckConfiguration.expiryDateLabel,
            };
        };
        return ValueCheckResultView;
    }(Backbone_1.View));
    exports.ValueCheckResultView = ValueCheckResultView;
});
